import { cn } from "@/components/ui/utils";

export function AppSidebarDividerItem({
  item,
  index,
  isBeforeOverline = false,
}: {
  item: { type: string };
  index: number;
  /**
   * Over a group's heading: the rule sits close under the row above and the
   * heading spaces itself below it, rather than centring in a row of its own.
   */
  isBeforeOverline?: boolean;
}) {
  return (
    <div
      key={item.type + index}
      className={cn(
        "pl-2 pr-2 [@container_(max-width:_50px)]:pl-4 [@container_(max-width:_50px)]:pr-4",
        isBeforeOverline ? "h-auto" : "h-8",
        isBeforeOverline ? "pt-2.25" : "pt-0",
        isBeforeOverline ? "pb-2" : "pb-0",
        "w-full flex items-center justify-center",
      )}
    >
      <div
        key={item.type + index}
        className="w-[calc(100%-0px)] h-px bg-border"
      />
    </div>
  );
}
